var map;
var cachedGeoJson;

import './_bootstrap';

(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.disableSearchExposedAjax = {
    attach: function (context) {
      Drupal.views.ajaxView.prototype.attachExposedFormAjax = function () {
        const that = this;
        this.exposedFormAjax = [];
        // Exclude the reset buttons so no AJAX behaviors are bound. Many things
        // break during the form reset phase if using AJAX.
        $(
          'input[type=submit], button[type=submit], input[type=image]',
          this.$exposed_form,
        )
          .not('[data-drupal-selector=edit-reset]')
          .not('[disable-exposed-ajax-submit]')
          .each(function (index) {
            const selfSettings = $.extend({}, that.element_settings, {
              base: $(this).attr('id'),
              element: this,
            });
            that.exposedFormAjax[index] = Drupal.ajax(selfSettings);
          });
      };
    }
  };

  Drupal.behaviors.communitiesModule = {
    attach: function (context) {
      $(once('communities-module', '.paragraph--type--communities', context)).each(function (e) {
        $('.paragraph--type--communities .header .center .list a.icon', context).on('click', function (e) {
          e.preventDefault();

          if ($(this).hasClass('active')) {
            return;
          }

          $(this).addClass('active');
          $('.paragraph--type--communities .header .center .map a.icon').removeClass('active');
          $('.paragraph--type--communities #communities-map, .paragraph--type--communities #communities-list').toggleClass('hidden');

          return false;
        });

        $('.paragraph--type--communities .header .center .map a.icon', context).on('click', function (e) {
          e.preventDefault();


          if ($(this).hasClass('active')) {
            return;
          }

          $(this).addClass('active');
          $('.paragraph--type--communities .header .center .list a.icon').removeClass('active');
          $('.paragraph--type--communities #communities-map, .paragraph--type--communities #communities-list').toggleClass('hidden');

          return false;
        });
      });
    }
  };

  Drupal.behaviors.addressGoogleMapInit = {
    attach: function (context) {
      $(once('addressGoogleMap','body .paragraph--type--address'), context).each(function() {
        $(document).on('geofieldMapInit', function (e, mapid) {
          var markers = Drupal.geoFieldMapFormatter.map_data[mapid].markers;

          $.each(markers, function (nid, marker) {
            marker.addListener("click", () => {
              window.location = this.geojsonProperties.url;
            });
          })

        });
      })
    }
  };

  Drupal.behaviors.locationsGoogleMapInit = {
    attach: function (context) {
      $(once('locationsGoogleMap', 'body .view-regions-map'), context).each(function() {
        $(document).on('geofieldMapInit', function (e, mapid) {

          if (mapid != 'geofield-map-view-regions-map-block-1--2') {
            return;
          }

          map = Drupal.geoFieldMapFormatter.map_data[mapid].map;
          // Load GeoJSON.
          var promise = jQuery.getJSON("/themes/custom/nsh/nsha-regions.geojson"); //same as map.data.loadGeoJson();

          promise.then(function(data) {
            cachedGeoJson = data; //save the geojson in case we want to update its values

            map.data.addGeoJson(cachedGeoJson,{idPropertyName:"id"});

            var bounds = new google.maps.LatLngBounds();

            map.data.forEach(function(feature){
              feature.getGeometry().forEachLatLng(function(latlng){
                bounds.extend(latlng);
              });
            });

            map.fitBounds(bounds, 0);

            map.data.setStyle(function(feature) {
              var region = feature.getProperty('name');
              var color = "gray";

              switch (region) {
                case 'Northern':
                  color = '#4db847';
                  break;
                case 'Eastern':
                  color = '#1d6184';
                  break;
                case 'Central':
                  color = '#9fbc43';
                  break;
                case 'Western':
                  color = '#16aaa7';
                  break;
              }

              return {
                fillColor: color,
                strokeColor: '#ffffff',
                fillOpacity: 0.75,
                strokeWeight: 1
              }
            });
          });

          map.data.addListener('mouseover', function(event) {
            map.data.revertStyle();
            map.data.overrideStyle(event.feature, {fillOpacity: 1});
          });

          map.data.addListener('mouseout', function(event) {
            map.data.revertStyle();
          });

          map.data.addListener('click', function(event) {
            var region = event.feature.getProperty('name');
            window.location = '/communities/' + region.toLowerCase() + '-zone';
          });

          jQuery(window).resize(function() {
            var bounds = new google.maps.LatLngBounds();
            map.data.forEach(function(feature){
              feature.getGeometry().forEachLatLng(function(latlng){
                bounds.extend(latlng);
              });
            });

            map.fitBounds(bounds, 0);
          });

        });
      })
    }
  };

  Drupal.behaviors.opportunityReadMore = {
    attach: function (context) {
      $(once('run-once', '.node-type--opportunity .opportunity-read-more a'), context).on('click', function (e) {
        $('.node-type--opportunity .apply-here').removeClass('apply-here');
        $(this).delete();
        return false;
      });
    }
  };

  Drupal.behaviors.opportunityCountdown = {
    attach: function (context) {
      $(once('run-once', 'body.node-opportunity .countdown'), context).each(function() {
        const exp = moment($('.countdown').data('date'));

        var timer = setInterval(function() {
          let now = moment().format();
          let diffDuration = moment.duration(exp.diff(now));

          if (diffDuration >= 0) {
            var days = exp.diff(now, 'days');
            $('.countdown > .days > strong').text(days);
            $('.countdown > .hours > strong').text(diffDuration.hours());
            $('.countdown > .minutes > strong').text(diffDuration.minutes());
            $('.countdown > .seconds > strong').text(diffDuration.seconds());
            $('.countdown').removeClass('invisible');
          }
          else {
            clearInterval(timer);
            $('.countdown').addClass('invisible');
          }
        }, 1000);
      });
    }
  }

  Drupal.behaviors.eventsCalendar = {
    attach: function (context) {
      $(once('run-once', 'a.count'), context).on('click', function (e) {
        var date = $(this).data('date');

        $('.calendar-events .calendar-event').hide();
        $('.calendar-main .calendar-day').not('.date-' + date).removeClass('active');

        if ($('.events-floater').length) {
          $('.events-floater').remove();
        }

        if ($(this).parent().parent().hasClass('active')) {
          $(this).parent().parent().removeClass('active');
        }
        else {
          var parent_row = $(this).closest('.calendar-week');
          var day_events = '';

          $('.calendar-events .calendar-wrap.date-' + date).each(function (e) {
            day_events += $(this).html();
          });

          $('<div class="events-floater"><div class="inside">' + day_events + '</div></div>').insertAfter(parent_row);
          $(this).parent().parent().addClass('active');
        }

        return false;
      });
    }
  };
})(jQuery, Drupal);
